import { FeatureCard } from '../components/FeatureCard';
import { Target, Zap, Layout, ShieldCheck } from 'lucide-react';
import { motion } from 'framer-motion';

export const Features = () => {
  const features = [
    {
      icon: Target,
      title: 'Immersive Roulette',
      description: 'Experience a beautifully designed roulette interface crafted around the wheel itself.'
    },
    {
      icon: Zap,
      title: 'Smooth Animation',
      description: 'Enjoy fluid wheel, chip and result animations tuned for a realistic feel.'
    },
    {
      icon: Layout,
      title: 'Modern Interface',
      description: 'Designed to feel native on desktop, tablet and mobile screens alike.'
    },
    {
      icon: ShieldCheck,
      title: 'Demo Experience',
      description: 'Enjoy the roulette experience using virtual credits only. Built with user-safety principles in mind.'
    }
  ];

  return (
    <section id="features" className="py-24 bg-charcoal-900 border-t border-gray-800">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <motion.h2 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-4xl md:text-5xl font-bold text-white mb-6"
          >
            Why Choose <span className="text-gold-500">Royal Roulette?</span>
          </motion.h2>
          <motion.p 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="text-gray-400 text-lg leading-relaxed"
          >
            Step into a premium environment designed around speed, style and excitement.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <FeatureCard 
              key={index}
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
              delay={index * 0.1}
            />
          ))}
        </div>
      </div>
    </section>
  );
};
